module.exports = __webpack_public_path__ + "static/media/ventajasdetox.5dd598ca.svg";